import { OpinionState, OPINION_STATES_MAP } from '@/constants/schema-constants'

export function getDeletedMessage(opinionState:OpinionState):string | undefined {
  return OPINION_STATES_MAP.get(opinionState)
}
